<div class="flex flex-col gap-5 overflow-hidden">
	<div class="flex flex-row items-end">
		<h2 class="pr-5">
			Undertakings Given ({{ (undertakings$ | async)?.length }})
		</h2>
		<app-button
			size="small"
			btn="primary"
			[icon]="ICON.ADD"
			size="small"
			(click)="addUndertaking()"
			>Add new</app-button
		>
	</div>
	<div class="flex flex-col gap-5 overflow-y-auto">
		<app-undertaking-item
			[undertaking]="undertaking"
			*ngFor="let undertaking of undertakings$ | async; trackBy: undertakingId"
		>
		</app-undertaking-item>
	</div>
</div>

<ng-container *ngIf="undertakingsDocSourceIdByMatterType$ | async as sourceId">
	<app-documents-word-matter-viewer
		*ngIf="!(useHtmlDocuments$ | async)"
		sourceId="{{ sourceId }}"
	></app-documents-word-matter-viewer>
</ng-container>
<div class="grid min-h-0" *ngIf="useHtmlDocuments$ | async">
	<app-document-matter-viewtor
		class="h-full"
		sourceId="ug"
	></app-document-matter-viewtor>
</div>
